import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import logo from "../assets/images/logo.webp"

export default function Header() {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navigation = [
    { name: "Home", href: "/" },
    { name: "Services", href: "/services" },
    { name: "About", href: "/about" },
    { name: "Contact", href: "/contact" },
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 bg-white z-50 transition-all duration-300 ${isScrolled ? 'shadow-xl' : 'shadow-lg'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0">
  <img src={logo} alt="Pinnacle Premiere Limo Logo" className=" w-52 h-20 object-contain" />
</Link>

          {/* Desktop Navigation */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              {navigation.map((item) => (
                <Link key={item.name} to={item.href}>
                  <span className={`font-medium transition-colors duration-300 cursor-pointer ${
                    location.pathname === item.href 
                      ? 'text-luxury-gold' 
                      : 'text-charcoal hover:text-luxury-gold'
                  }`}>
                    {item.name}
                  </span>
                </Link>
              ))}
              <Link to="/contact">
                <button className="bg-luxury-gold text-deep-black hover:bg-yellow-600 rounded font-semibold px-6 py-2">
                  Book Now
                </button>
              </Link>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-charcoal hover:text-luxury-gold"
            >
              {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            {navigation.map((item) => (
              <Link key={item.name} to={item.href}>
                <span 
                  className={`block px-3 py-2 transition-colors duration-300 cursor-pointer ${
                    location.pathname === item.href 
                      ? 'text-luxury-gold' 
                      : 'text-charcoal hover:text-luxury-gold'
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.name}
                </span>
              </Link>
            ))}
            <Link to="/contact">
              <button className="w-full mt-4 rounded bg-luxury-gold text-deep-black hover:bg-yellow-600 font-semibold py-2">
                Book Now
              </button>
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}